export const CONTENTS_BG = 'bg-primary-White border borer-gray-ea';
